import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function HotelPurchaseHotelTable(props: {
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const name: any = `approvalable.hotelPurchases.${props.parentIndex}.hotelPurchaseHotels`;

  const value = HOCWatchValue({ keys: [name] });

  const columns = [
    {
      header: t('common:check_in'),
      accessorKey: 'checkIn',
      minSize: 150,
      maxSize: 180,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:check_out'),
      accessorKey: 'checkOut',
      minSize: 150,
      maxSize: 180,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:number_of_night'),
      accessorKey: 'night',
      minSize: 100,
      dataType: ColumnDataType.null,
      disabled: true,
    },
    {
      header: t('common:number_of_room'),
      accessorKey: 'room',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
    {
      header: t('common:room_type'),
      accessorKey: 'hotelRoomName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={value[name]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
